import React, { useEffect, useState } from "react";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core/styles';
import { Component, Fragment } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from "@material-ui/core/Grid";
import IconContentAdd from "@material-ui/icons/Add";
import IconCancel from "@material-ui/icons/Cancel";
import SendIcon from '@material-ui/icons/Send';
//import './MyAppBar.css';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { useForm, Controller } from 'react-hook-form';
import { green, purple } from '@material-ui/core/colors';
import { useVersion, useDataProvider } from 'react-admin';
import { GetPublicAdress } from '../src/global'
import FormLabel from '@material-ui/core/FormLabel';


import
{

    required,
    showNotification,
    SaveButton,
    SimpleForm,
    TextInput,
    CREATE,
    REDUX_FORM_NAME,
} from "react-admin";



function getWindowDimensions()
{
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}




const styles = theme => ({


    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    }
    ,
    root: {
        background: '#FFFFFF',
        border: '1px solid #F5681C',

        color: '#F5681C',
        //maxWidth: '200px',
        height: 48,
        // padding: '0 30px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        margin: '10px 0px',
        borderRadius: '2px',
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: 16,
        lineHeight: "24px",
        textAlign: "center",
        textTransform: "uppercase",
        '&:hover': {
            backgroundColor: '#c5c6c7',
        },

    },
    label: {
        textTransform: 'capitalize',

    },

    halfText: {
        minWidth: "200px",
        maxWidth: "500px",


    },
    typography: {
        subtitle1: {
            fontSize: 12,
        },
        body1: {
            fontWeight: 500,
        },
        button: {
            fontStyle: 'italic',
        },
    },
    palette: {
        primary: 'green',
    },
});

const PrimColorButton = withStyles((theme) => ({
    root: {
        color: '#ff',
        backgroundColor: '#F5681C',
        '&:hover': {
            backgroundColor: '#F5681C',
        },
    },
}))(Button);

const SecColorButton = withStyles((theme) => ({
    root: {
        color: '#ff',
        backgroundColor: '#848484',
        '&:hover': {
            backgroundColor: '#848484',
        },
    },
}))(Button);


const buttonFont = createMuiTheme => ({
    typography: {
        MuiButton: {
            fontSize: '1rem',
        },
    },
});



const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;



class PostQuickCreateButton extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            FirstName: '',
            LastName: '',
            Telephone: '',
            Email: '',
            FencerFirstName: '',
            FencerLastName: '',
            Age: 11,
            Comment: '',
            AgeerrorText: '',
            EmailerrorText: '',
            FirstNameerrorText: '',
            TelephoneerrorText: '',
            FencerFerrorText: '',
            FencerLerrorText: '',
            Sex: 'male',
            PrevCall: 'no'


        };

        this.setState({ IsError: false })


    }

    handleChange1 = (event, value) =>
    {
        this.setState({ Sex: value });
    };

    handleChange2 = (event, value) =>
    {
        this.setState({ PrevCall: value });
    };

    handleChange = (event) =>
    {
        if (event != null)
        {

            if ([event.target.id] == "Email")
            {
                if (event.target.value.match(emailRegex))
                {
                    this.setState({ EmailerrorText: '' })
                }
                else
                {
                    this.setState({ EmailerrorText: 'Укажите email правильно' })

                }
            }

            if ([event.target.id] == "FirstName")
            {
                if (event.target.value != null && event.target.value != '')
                {
                    this.setState({ FirstNameerrorText: '' })
                    // this.setState({ IsError: IsError && false })
                }
                else
                {
                    this.setState({ FirstNameerrorText: 'Укажите Имя родителя правильно' })

                }
            }

            if ([event.target.id] == "LastName")
            {
                if (event.target.value != null && event.target.value != '')
                {
                    this.setState({ LastNameerrorText: '' })
                    // this.setState({ IsError: IsError && false })
                }
                else
                {
                    this.setState({ LastNameerrorText: 'Укажите Фамилию родителя правильно' })

                }
            }

            if ([event.target.id] == "Telephone")
            {
                if (event.target.value != null && event.target.value != '')
                {
                    this.setState({ TelephoneerrorText: '' })

                }
                else
                {
                    this.setState({ TelephoneerrorText: 'Укажите телефон правильно' })

                }
            }

            if ([event.target.id] == "FencerFirstName")
            {
                if (event.target.value != null && event.target.value != '')
                {
                    this.setState({ FencerFerrorText: '' })

                }
                else
                {
                    this.setState({ FencerFerrorText: 'Укажите Имя фехтовальщика правильно' })

                }
            }

            if ([event.target.id] == "FencerLastName")
            {
                if (event.target.value != null && event.target.value != '')
                {
                    this.setState({ FencerLerrorText: '' })

                }
                else
                {
                    this.setState({ FencerLerrorText: 'Укажите Фамилию фехтовальщика правильно' })

                }
            }

            if ([event.target.id] == "Age")
            {
                if (event.target.value != null && event.target.value != '')
                {
                    this.setState({ AgeerrorText: '' })

                }
                else
                {
                    this.setState({ AgeerrorText: 'Укажите возраст правильно' })

                }
            }



            this.setState({ [event.target.id]: event.target.value });


        } else
        {

        }
    };







    handleClick = () =>
    {
        this.setState({ showDialog: true });
    };

    handleCloseClick = () =>
    {
        this.setState({ showDialog: false });
    };


    PostCreateSignIn = () =>
    {

        // PUT request using fetch with async/await
        async function updatePost(nameI, surnameI, ageI, sexI, contactNameI, telephoneI, emailI, infoI)
        {

            const requestOptions = {

                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Accept": "application/json",
                },
                mode: 'cors',


                method: 'POST',
                // mode: 'no-cors',
                // headers: {  'Content-Type': 'application/json'},
                // headers: { 'Access-Control-Allow-Origin': '*' },
                // headers: { 'Access-Control-Allow-Headers': '*' },


                body: JSON.stringify(
                    {
                        name: nameI,
                        surname: surnameI,
                        age: ageI,
                        sex: sexI,
                        contactName: contactNameI,
                        telephone: telephoneI,
                        email: emailI,
                        info: infoI
                    })
            };


            try
            {

                /*
                                fetch( GetPublicAdress() +'/CreateSignIn', requestOptions)
                                    .then(() =>
                                    {
                                        showNotification('Comment approved');
                
                                    })
                                    .catch((e) =>
                                    {
                                        showNotification('Error: comment not approved', 'warning')
                                    });*/


                var ss = process.env.PUBLIC_URL + "Fencing.Api/v1.0/" + 'CreateSignIn';
                const response = await fetch(

                    GetPublicAdress() + '/CreateSignIn'
                    // 'http://alexander.abc/Fencing/CreateSignIn'
                    //'http://alexander.abc/Fencing/CreateSignIn'
                    , requestOptions);

                if (response.ok)
                {
                    const data = await response.json();
                } else
                {
                    var ss = response.statusText;
                }
            }
            catch (e)
            {
                return e;
            }


        }


        var isErrorN = false;
        var emailTxt = document.getElementById('Email')
        if (emailTxt.value.match(emailRegex))
        {
            this.setState({ EmailerrorText: '' });
        } else
        {
            this.setState({ EmailerrorText: 'Укажите email правильно' })

            isErrorN = true;
        }

        var firstnTxt = document.getElementById('FirstName')

        if (firstnTxt.value != '')
        {
            this.setState({ FirstNameerrorText: '' })
        } else
        {
            this.setState({ FirstNameerrorText: 'Укажите Имя родителя правильно' })

            isErrorN = true;
        }

        var firstnTxt = document.getElementById('LastName')

        if (firstnTxt.value != '')
        {
            this.setState({ LastNameerrorText: '' })
        } else
        {
            this.setState({ LastNameerrorText: 'Укажите Фамилию родителя правильно' })

            isErrorN = true;
        }

        var telTxt = document.getElementById('Telephone')
        if (telTxt.value != '')
        {
            this.setState({ TelephoneerrorText: '' })
        } else
        {
            this.setState({ TelephoneerrorText: 'Укажите телефон правильно' })

            isErrorN = true;
        }

        var fencerFirstNameTxt = document.getElementById('FencerFirstName')
        if (fencerFirstNameTxt.value != '')
        {
            this.setState({ FencerFerrorText: '' })
        } else
        {
            this.setState({ FencerFerrorText: 'Укажите Имя фехтовальщика правильно' })

            isErrorN = true;
        }

        var fencerLastNameTxt = document.getElementById('FencerLastName')
        if (fencerLastNameTxt.value != '')
        {
            this.setState({ FencerLerrorText: '' })
        } else
        {
            this.setState({ FencerLerrorText: 'Укажите Фамилию фехтовальщика правильно' })

            isErrorN = true;
        }

        var ageTxt = document.getElementById('Age')
        if (ageTxt.value != '')
        {
            this.setState({ AgeerrorText: '' })
        } else
        {
            this.setState({ AgeerrorText: 'Укажите возраст правильно' })

            isErrorN = true;
        }

        var ageTxt = document.getElementById('Age')
        if (ageTxt.value != '')
        {
            this.setState({ AgeerrorText: '' })
        } else
        {
            this.setState({ AgeerrorText: 'Укажите возраст правильно' })

            isErrorN = true;
        }

        if (this.state.EmailerrorText == '' && this.state.FirstNameerrorText == '' && this.state.TelephoneerrorText == '' && this.state.FencerFerrorText == '' && this.state.FencerLerrorText == '' && this.state.AgeerrorText == '')
        {
            this.state.IsError = false;
        }

        if (!isErrorN)
        {


            if (this.state.PrevCall == "yes")
            {
                this.state.Comment = this.state.Comment + '  (Предварительный разговор состоялся по телефону)';
            }

            /*     this.handleChange("FencerFirstName");
                 this.handleChange("FencerLastName");
                 this.handleChange("Age");
                 this.handleChange("sex");
                 this.handleChange("FirstName");
                 this.handleChange("LastName");
                 this.handleChange("Telephone");*/

            updatePost(this.state.FencerFirstName, this.state.FencerLastName, this.state.Age, this.state.Sex == 'male', this.state.FirstName + ' ' + this.state.LastName,
                this.state.Telephone, this.state.Email, this.state.Comment);

            this.handleCloseClick();
        }
    };


    handleSaveClick = () =>
    {
        const { submit } = this.props;


        // Trigger a submit of our custom quick create form
        // This is needed because our modal action buttons are oustide the form
        submit("post-quick-create");
    };

    handleSubmit = values =>
    {
        const { change, fetchStart, fetchEnd, showNotification } = this.props;

        // Dispatch an action letting react-admin know a API call is ongoing
        fetchStart();

        /*
        // As we want to know when the new post has been created in order to close the modal, we use the
        // dataProvider directly
        dataProvider(CREATE, "posts", { data: values })
          .then(({ data }) => {
            // Update the main react-admin form (in this case, the comments creation form)
            change(REDUX_FORM_NAME, "post_id", data.id);
            this.setState({ showDialog: false });
          })
          .catch(error => {
            showNotification(error.message, "error");
          })
          .finally(() => {
            // Dispatch an action letting react-admin know a API call has ended
            fetchEnd();
          });
          */
    };

    render()
    {
        const { showDialog } = this.state;
        const { isSubmitting } = this.props;
        const { classes } = this.props;

        // const { control, errors: fieldsErrors } = useForm();
        return (
            <Fragment>
                {/* <ThemeProvider theme={buttonFont}> */}
                <Button classes={{ root: classes.root }} onClick={this.handleClick}  >
                    ЗАПИСАТЬСЯ
                </Button>
                {/* </ThemeProvider> */}
                <Dialog open={showDialog} onClose={this.handleCloseClick} aria-label="Записаться на занятия"        >
                    <DialogTitle>Записаться на занятия</DialogTitle>
                    <DialogContent>
                        <form noValidate autoComplete="off">
                            <Grid container spacing={12}>
                                <Grid item xs={12} sm={6}>
                                    <TextField id="FirstName" label="Имя родителя" variant="outlined" required fullWidth style={{ margin: 10 }} className={{ halfText: classes.halfText }} onChange={this.handleChange} error={this.state.FirstNameerrorText != ''} errorText={this.state.FirstNameerrorText} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField id="LastName" label="Фамилия родителя" variant="outlined" required fullWidth style={{ margin: 10 }} onChange={this.handleChange} error={this.state.LastNameerrorText != ''} errorText={this.state.LastNameerrorText} />
                                </Grid>
                                <Grid item xs={12} sm={6}>

                                    <TextField id="Telephone" label="Контактный телефон" variant="outlined" required fullWidth style={{ margin: 8 }} onChange={this.handleChange} error={this.state.TelephoneerrorText != ''} errorText={this.state.TelephoneerrorText} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField id="Email" label="Email" variant="outlined" required fullWidth style={{ margin: 8 }} onChange={this.handleChange} error={this.state.EmailerrorText != ''} errorText={this.state.EmailerrorText} />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormLabel id="PrevCallLbl" component="legend" style={{ margin: 10 }}>Пол:</FormLabel>
                                    <RadioGroup id="Sex" row aria-label="position" name="SexName" defaultValue="male" label="Пол фехтовальщика" onChange={this.handleChange1} value={this.state.value}>
                                        <FormControlLabel
                                            // value="top"
                                            control={<Radio color="primary" />}
                                            label="Муж."
                                            labelPlacement="top"
                                            //   checked="True"

                                            value="male"
                                        />
                                        <FormControlLabel
                                            value="female"
                                            control={<Radio color="primary" />}
                                            label="Жен."
                                            labelPlacement="top"


                                        // value="False"
                                        />

                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormLabel id="PrevCallLbl" component="legend" style={{ margin: 10 }}>Предварительный разговор состоялся по телефону:</FormLabel>
                                    <RadioGroup id="Sex" row aria-label="position" name="PrevCallName" defaultValue="no" label="Предварительный разговор состоялся по телефону" onChange={this.handleChange2} value={this.state.value}>
                                        <FormControlLabel
                                            // value="top"
                                            control={<Radio color="primary" />}
                                            label="Да"
                                            labelPlacement="top"
                                            //   checked="True"

                                            value="yes"
                                        />
                                        <FormControlLabel
                                            value="no"
                                            control={<Radio color="primary" />}
                                            label="Нет"
                                            labelPlacement="top"


                                        // value="False"
                                        />

                                    </RadioGroup>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField id="FencerFirstName" label="Имя фехтовальщика" required variant="outlined" fullWidth style={{ margin: 10 }} onChange={this.handleChange} error={this.state.FencerFerrorText != ''} errorText={this.state.FencerFerrorText} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField id="FencerLastName" label="Фамилия фехтовальщика" required variant="outlined" fullWidth style={{ margin: 10 }} onChange={this.handleChange} error={this.state.FencerLerrorText != ''} errorText={this.state.FencerLerrorText} />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField id="Age" type="number" defaultValue="10" label="Возраст фехтовальщика" required variant="outlined" fullWidth style={{ margin: 8 }} onChange={this.handleChange} error={this.state.AgeerrorText != ''} errorText={this.state.AgeerrorText} InputProps={{ inputProps: { max: 100, min: 5 } }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField id="Comment" defaultValue="" label="Коментарий" variant="outlined" multiline
                                        rows={4} fullWidth style={{ margin: 8 }} onChange={this.handleChange} />
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>

                    <DialogActions>


                        <SecColorButton label="ra.action.cancel" onClick={this.handleCloseClick} color="secondary" autoFocus variant="contained">
                            Отмена
                            {/* <IconCancel style={{ margin: 2 }} /> */}
                        </SecColorButton>


                        <PrimColorButton onClick={this.PostCreateSignIn} color="primary" autoFocus variant="contained">
                            Записаться
                            {/* <SendIcon style={{ margin: 2 }} /> */}
                        </PrimColorButton>
                    </DialogActions>

                </Dialog>
            </Fragment>
        );
    }
}

export default withStyles(styles)(PostQuickCreateButton);